import { CalculateData, CalculateResult, CalculatorItem } from '@product/const';
import { StateUtils } from '@spartacus/core';
import { CALCULATORS, CALCULATOR_RESULT } from '../product-state';

export const LOAD_CALCULATORS = '[CustomCatalog] Calculators Load';
export const LOAD_CALCULATORS_SUCCESS = '[CustomCatalog] Calculators Load Success';
export const LOAD_CALCULATORS_FAIL = '[CustomCatalog] Calculators Load Fail';
export const CALCULATE = '[CustomCatalog] Calculate';
export const CALCULATE_SUCCESS = '[CustomCatalog] Calculate Success';
export const CALCULATE_FAIL = '[CustomCatalog] Calculate Fail';
export const RESET_CALCULATE_RESULT = '[CustomCatalog] Reset Calculate Result';

export class LoadCalculators extends StateUtils.EntityLoadAction {
  readonly type = LOAD_CALCULATORS;

  constructor(public productCode: string) {
    super(CALCULATORS, productCode);
  }
}

export class LoadCalculatorsSuccess extends StateUtils.EntitySuccessAction {
  readonly type = LOAD_CALCULATORS_SUCCESS;

  constructor(
    public productCode: string,
    public payload: CalculatorItem[],
  ) {
    super(CALCULATORS, productCode, payload);
  }
}

export class LoadCalculatorsFail extends StateUtils.EntityFailAction {
  readonly type = LOAD_CALCULATORS_FAIL;

  constructor(
    public productCode: string,
    payload: any,
  ) {
    super(CALCULATORS, productCode, payload);
  }
}

export class Calculate extends StateUtils.LoaderLoadAction {
  readonly type = CALCULATE;

  constructor(public payload: CalculateData) {
    super(CALCULATOR_RESULT);
  }
}

export class CalculateSuccess extends StateUtils.LoaderSuccessAction {
  readonly type = CALCULATE_SUCCESS;

  constructor(public payload: CalculateResult) {
    super(CALCULATOR_RESULT);
  }
}

export class CalculateFail extends StateUtils.LoaderFailAction {
  readonly type = CALCULATE_FAIL;

  constructor(payload: any) {
    super(CALCULATOR_RESULT, payload);
  }
}

export class ResetCalculateResult extends StateUtils.LoaderResetAction {
  readonly type = RESET_CALCULATE_RESULT;

  constructor() {
    super(CALCULATOR_RESULT);
  }
}

export type CalculatorsAction =
  | LoadCalculators
  | LoadCalculatorsSuccess
  | LoadCalculatorsFail
  | Calculate
  | CalculateSuccess
  | CalculateFail
  | ResetCalculateResult;
